export const ESSENTIAL_BANNER_TEXT = {
  description:
    'We use cookies to enhance your browsing experience. By clicking "Accept", you consent to the use of cookies.',
  accept: 'Accept',
  link: 'Learn More',
};
